import { Component, OnInit, OnDestroy } from '@angular/core';
import { Unsubscribable } from 'rxjs';

import { UserAuth, ValuesExchangeProvider } from '@nrwl/common-lib';

import { WizardNavigatorService } from '../wizard-navigator.service';

@Component({
  selector: 'nrwl-user-security',
  templateUrl: './user-security.component.html',
  styleUrls: ['./user-security.component.scss']
})
export class UserSecurityComponent implements OnInit, OnDestroy {
  private unsubscribable: Unsubscribable;
  userInfo: any = {}; //eslint-disable-line

  constructor(
    private readonly exchange: ValuesExchangeProvider,
    private readonly wizardNavigatorService: WizardNavigatorService,
    private readonly userAuth: UserAuth
  ) {}

  ngOnInit(): void {
    this.unsubscribable = this.exchange.registerInterest('user-profile-info', userInfo => {
      this.userInfo = userInfo;
    });
  }

  ngOnDestroy(): void {
    if (this.unsubscribable) {
      this.unsubscribable.unsubscribe();
    }
  }

  openChangePasswordWizard(): void {
    let wizardId = 'update_user_password';
    if (this.userAuth.canManagePermissions() && this.userAuth.getUserName() !== this.userInfo?.username) {
      wizardId = 'update_user_password_admin';
    }
    const defaultParams = { username: this.userInfo.username, userId: this.userInfo.id };
    this.wizardNavigatorService.navigateToWizard(wizardId, defaultParams);
  }

  isLocalUser(): boolean {
    return this.userAuth.isLocalUser();
  }

  isEditable(): boolean {
    return this.userInfo.origin === 'local' || this.userAuth.isAuthedFor('MANAGE_PERMISSIONS');
  }
}
